import type { UrlsType } from '../types';
import { getUrl, type Query } from '../route-types';
import { buildFullPath } from '../routing';

const urlList = {
    base: () => '/admin',
    payments: (
        query?: Record<string, string | number | boolean>,
        host?: string
    ) => buildFullPath('/admin/payments', host, query),
    user: (id: string, baseUrl?: string) => getUrl('/admin/users/[id]', { params: { id }, baseUrl }),
    billingSettings: () => getUrl('/admin/config/billing-settings'),
    identityDocument: (id: string, document: string, download = false)=> {
        return getUrl(
            '/admin/users/[id]/document',
            { params: { id }, query: { document, download: download ? '1': '' }}
        );
    },
    room: (id: string) => getUrl('/admin/rooms/[id]', { params: { id } }),
    roomSnapshot: (roomId: string, snapshot: string, baseUrl?: string) => {
        return `${baseUrl || ''}/admin/room/storage/${roomId}/${snapshot}`;
    },
    userPermissions: (id: string) => getUrl('/admin/permissions/[id]', { params: { id } }),
    metrics: () => '/admin/metrics',
    terms: (query: Query) => getUrl('/admin/terms', { query }),
    healthz: () => '/healthz',
    alertsSettings: () => getUrl('/admin/rooms/alerts/settings'),
    productTimePackagesByCountries: () => getUrl('/admin/utils/time-packages-by-countries'),
    featureToggles: () => getUrl('/admin/utils/feature-toggles'),
    streamingSettings: () => getUrl('/admin/utils/streaming'),
};

const URLS: UrlsType<typeof urlList> = urlList;

export { URLS };
